import React from "react";
import RevealAnimation from "../RevealAnimation";
import { navigate } from "gatsby";
import "./articlesCTASection.scss";

function ArticlesCTASection() {
  return (
    <section className="articles-cta-section">
      <div className="cta-bg-elements">
        <div className="cta-orb cta-orb-1" />
        <div className="cta-orb cta-orb-2" />
      </div>

      <div className="articles-cta-content body-container">
        <RevealAnimation animation="fade" delay={0.1}>
          <div className="cta-card">
            <div className="cta-card-left">
              <span className="cta-badge">Get in Touch</span>
              <h2 className="cta-title">Have an exciting project in mind?</h2>
              <p className="cta-description">
                Let's discuss how we can help bring your ideas to life with
                cutting-edge technology and expert engineering.
              </p>
            </div>
            <div className="cta-card-right">
              <button
                className="cta-btn cta-btn--primary"
                onClick={() => navigate("/contact-us")}
              >
                Let's Talk
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </button>
              <button
                className="cta-btn cta-btn--secondary"
                onClick={() => navigate("/insights")}
              >
                View All Insights
              </button>
            </div>
          </div>
        </RevealAnimation>
      </div>
    </section>
  );
}

export default ArticlesCTASection;
